import React, {useEffect, useState} from 'react'
import Input from './Input'

import PhoneNumber from 'awesome-phonenumber'
import AutoComplete from './AutoComplete'

import Utils from 'EurestoFonction/Utils'

export default (props) => {
  let pn = props.value && new PhoneNumber(
    new PhoneNumber('+' + props.value.replace('+', '')).getRegionCode() && ('+' + props.value.replace('+', '')) ||
    props.value
    || '',
    new PhoneNumber('+' + props.value.replace('+', '')).getRegionCode() || props.defaultRegionCode || 'FR')

  const [country, setCountry] = useState(props.value && pn.getRegionCode() || props.defaultRegionCode || 'FR')

    useEffect(() => {
        if(!props.value && props.defaultRegionCode) {
            setCountry(props.defaultRegionCode || 'FR')
        }
    }, [props.defaultRegionCode])

  const countryCode = '+' + PhoneNumber.getCountryCodeForRegionCode(country)

  const [value, setValue] = useState(props.value && pn.getNumber('significant') || props.value || '')

  const [element, setElement] = useState(null)

  if (props.onChange) {
    useEffect(
      () => {
        if (value !== undefined || country !== undefined) {
            (PhoneNumber.getCountryCodeForRegionCode(country) + value) !== props.value
            && props.onChange(value && PhoneNumber.getCountryCodeForRegionCode(country) + value || '', props.name, element)
        }
      },
      [value, country]
    )
  }

  const onChange = (value, name, e) => {
    setElement(e)
    setValue(value)
  }

  const onChangeCountry = (e) => {
    setCountry(e)
  }

  return (
    <Input style={Object.assign({ padding: 0, marginBottom: 5 }, props.style || {})}
               id={props.id || ''}
               inline={props.inline}
               name={props.name}
               autoFocus={props.autoFocus}
               className={props.className || ''}
               value={value && value !== 'NULL' ? value : ''}
               onChange={onChange}
               type={'phone'}
               onClick={props.onClick}
               InputProps={{
                 ...props.InputProps,
                 startAdornment: (
                   <AutoComplete
                     key={country}
                     MenuProps={{
                       style: { width: 98 }
                     }}
                     style={{
                       width: 98,
                       position: 'relative',
                       //marginLeft: -10,
                       marginRight: 5,
                       borderRight: '2px solid ' + EurestoColor('EurestoPrimary')
                     }}
                     inputStyle={{ padding: 0, width: 98, marginBottom: 0, marginTop: 0 }}
                     disabled={props.disabled || false}
                     onChange={onChangeCountry}
                     options={
                       Utils.optionsPays('code_alpha2')
                         .map(option =>
                           country === option.value && ({ ...option, label: option.label + ' ' + (countryCode) })
                           || option)}
                     data={country}/>
                 )
               }}
               title={props.title}
               disabled={props.disabled}
               inputRef={props.inputRef}
               placeholder={props.placeholder || ''}
               onKeyPress={props.onKeyPress}/>
  )
}



// WEBPACK FOOTER //
// ./app/Components/PhoneInput.js